document.addEventListener('DOMContentLoaded', () => {
  const sorter = document.querySelector('.filters .facets-container.sorting');
  const filterContainer = document.querySelector('.ed-search .filters');
  const desktopSort = document.querySelector('.desktop-sort');
  const closeDrawer = document.querySelector('.ed-search .mobile-facets__close');

  closeDrawer.addEventListener('click', () => {
    if (document.body.classList.contains('overflow-hidden-mobile')) {
      document.body.classList.remove('overflow-hidden-mobile');
    }
  });

  function moveSorter() {
    const screenWidth = window.innerWidth;

    if (screenWidth >= 990) {
      if (!desktopSort.contains(sorter)) {
        desktopSort.appendChild(sorter);
      }
    } else {
      if (!filterContainer.contains(sorter)) {
        filterContainer.appendChild(sorter);
      }
    }
  }

  moveSorter();

  window.addEventListener('resize', moveSorter);
});
